export default defineNuxtPlugin((nuxtApp) => {

})
